module.exports = __webpack_public_path__ + "img/menuTopLogo.940a312f.png";